import { Modal, Box } from '@mui/material';
import AdModalBasic from './AdModalBasic';
import { useModalStore } from 'src/stores/ModalStore';
import ModalRenderer from './ModalRenderer';
import styled from 'styled-components';

const BottomModalLayout = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: white; /* or use theme if available */
  border-radius: 8px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  padding: 24px;
  width: calc(100vw - 40px);
`;

const AppModal = () => {
  const open = useModalStore((state)=>state.open);
  const type = useModalStore((state)=>state.type);
  const modalSetField = useModalStore((state)=>state.setField)
  const modalReset = useModalStore((state)=>state.reset)
  const modalWidth = useModalStore((state)=>state.width)
  const modalpadding = useModalStore((state)=>state.padding)

  const renderContent = () => {
    switch (type) {
      case 'BASIC':
        return <AdModalBasic/>;
      case 'CENTER':
        return <ModalRenderer />;
      case 'BOTTOM':
        return <ModalRenderer/>;
      default:
        return null;
    }
  };

  const handleClose = () => {
    modalSetField('open',false);
    modalReset()
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <div>
        {(type === 'BASIC' || type === 'CENTER') && (
          <Box
            sx={{
              position: 'absolute' as const,
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              bgcolor: 'background.paper',
              borderRadius: 2,
              boxShadow: 24,
              p: modalpadding,
              width: modalWidth,
            }}
          >
            {renderContent()}
          </Box>)}
        {type === 'BOTTOM' &&
          <BottomModalLayout>
            {renderContent()}
          </BottomModalLayout>
        }
      </div>
    </Modal>
  );
};

export default AppModal;